var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDevice = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M700.051,75h-400.1A49.975,49.975,0,0,0,250,125V875a49.975,49.975,0,0,0,49.949,50h400.1A49.975,49.975,0,0,0,750,875V125A49.975,49.975,0,0,0,700.051,75ZM462.5,100h75a12.5,12.5,0,0,1,0,25h-75A12.5,12.5,0,0,1,462.5,100ZM500,900a25,25,0,1,1,25-25A25,25,0,0,1,500,900Zm200-75H300V150H700V825Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDevice, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Device.9cc2b864.svg";
export { ForwardRef as ReactComponent };